import { gql } from "@apollo/client";

const GET_MEDICO_EVALUADOR = gql`
  query medicoEvaluador($idEvaluacion : Int!) {
    medicoEvaluador(idEvaluacion : $idEvaluacion){
      profesional {
        idProfesional
        idCalificacion
        idTipoProfesional
        idClaseMonitoreo
      }
      figuraProfesional {
        idFiguraProfesional
      }
      mostrar
    }
  }
`;

export default GET_MEDICO_EVALUADOR;